document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.trust-accordion-acevac').forEach(function (container) {

    var accordions = container.querySelectorAll(':scope > details');

    accordions.forEach(function (accordion) {

      accordion.addEventListener('toggle', function () {

        if (accordion.open) {

          accordions.forEach(function (otherAccordion) {

            if (otherAccordion !== accordion) {
              otherAccordion.removeAttribute('open');
            }

          });

        }

      });

    });

  });

});